import React from "react";
import { Pagination as RaPagination } from "react-admin";

const Pagination = ({
	rowsPerPageOptions = [25, 50, 100, 250, 500],
	...props
}) => <RaPagination rowsPerPageOptions={rowsPerPageOptions} {...props} />;

export default Pagination;
